import React, { createContext, useContext, useMemo, useState } from 'react'

const HeaderSearchContext = createContext(null)

export const HeaderSearchProvider = ({ children }) => {
  const [query, setQuery] = useState('')
  const [scope, setScope] = useState(null)

  const value = useMemo(
    () => ({
      query,
      setQuery,
      scope,
      setScope,
      placeholder:
        scope === 'event-registrations'
          ? 'Search registrations…'
          : 'Search...'
    }),
    [query, scope]
  )

  return (
    <HeaderSearchContext.Provider value={value}>{children}</HeaderSearchContext.Provider>
  )
}

export const useHeaderSearch = () => {
  const ctx = useContext(HeaderSearchContext)
  if (!ctx) {
    throw new Error('useHeaderSearch must be used within HeaderSearchProvider')
  }
  return ctx
}

/** Optional hook for pages that may render outside the dashboard layout. */
export const useHeaderSearchOptional = () => useContext(HeaderSearchContext)
